export const setInitialVideoState = videoProp => {
  return {
    videoData: videoProp,
    videoApiDataFailed: false,
    originalVideo: null,
    fetchedByUUID: false,
    isForceLoadVideo: false
  };
};

export const VideoApiActionTypes = {
  SET_ORIGINAL: "SET_ORIGINAL",
  SET_ORIGINAL_FROM_API: "SET_ORIGINAL_FROM_API",
  SET_NEXT: "SET_NEXT",
  SET_NEXT_FROM_API: "SET_NEXT_FROM_API",
  SET_API_FAILED: "SET_API_FAILED",
  SET_NEXT_FROM_FORCE_LOAD: "SET_NEXT_FROM_FORCE_LOAD"
};

/**
 * A reducer function for the Video API state.
 * @param {object} state - The current state of the Video API.
 * @param {object} action - The action to be performed on the state.
 * @returns {object} The new state of the Video API.
 */
export const videoApiReducer = (state, action) => {
  switch (action.type) {
    case VideoApiActionTypes.SET_ORIGINAL_FROM_API:
      return {
        videoData: action.videoData,
        videoApiDataFailed: false,
        originalVideo: action.videoData,
        fetchedByUUID: true
      };
    case VideoApiActionTypes.SET_API_FAILED:
      return {
        ...state,
        videoApiDataFailed: true
      };
    case VideoApiActionTypes.SET_NEXT:
      return {
        ...state,
        videoData: action.videoData
      };
    case VideoApiActionTypes.SET_NEXT_FROM_API:
      return {
        ...state,
        videoData: action.videoData,
        videoApiDataFailed: false
      };
    case VideoApiActionTypes.SET_ORIGINAL:
      return {
        ...state,
        videoData: action.videoData,
        originalVideo: action.videoData
      };
    case VideoApiActionTypes.SET_NEXT_FROM_FORCE_LOAD:
      return {
        ...state,
        videoData: action.videoData,
        originalVideo: action.videoData,
        isForceLoadVideo: true
      };
    default:
      return state;
  }
};
